module.exports = __webpack_public_path__ + "static/img/5-4.e71252a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/components/past-review/5-4.png
// module id = 9Wjw
// module chunks = 25